import React from 'react'
import Select from "react-select";


const MonthSelector = ({ selectedYear, onChange }) => {
    const currentMonth = new Date().getMonth() + 1; // 1-12
    const monthNames = [
        {label:"January", value:1},
        {label:"Febuary", value: 2},
        {label:"March", value: 3},
        {label:"April", value: 4},
        {label: "May", value:5},
        {label:"June", value:6},
        {label:"July", value:7},
        {label:"August", value:8},
        {label:"September", value:9},
        {label:"October", value: 10},
        {label:"November", value:11},
        {label:"December", value:12}
      ];
    
    // Sort months: current month first, then previous months in reverse order, then December last
    // Example (if current is November): November, October, September, ..., January, December
    const currentMonthObj = monthNames[currentMonth - 1]; // Current month
    const previousMonths = monthNames.slice(0, currentMonth - 1).reverse(); // Previous months in reverse (Oct, Sep, Aug, ..., Jan)
    const december = currentMonth !== 12 ? [monthNames[11]] : []; // December (if not current month)
    
    const sortedMonths = [
      currentMonthObj, // Current month first
      ...previousMonths, // Previous months in reverse order
      ...december // December last
    ];
  
  return (
    <Select
    placeholder="Month:"
    // defaultValue={}
    onChange={onChange}
    options={sortedMonths?.map(({label, value}) => ({
      label,
      value,
    }))}
    loadingMessage={() => "Please wait, filterby is loading..."}
    styles={{
      container: (base) => ({
        ...base,
        border: "1px solid",
        borderRadius: "15px",
      }),
      control: (base) => ({
        ...base,
        borderRadius: "15px",
      }),
    }}
  />

  )
}

export default MonthSelector